import './LocationProfileRows.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import cxHelpers from 'util/className';

import LocationProfileRow from '../LocationProfileRow';

@cxHelpers('LocationProfileRows')
export default class LocationProfileRows extends PureComponent {
  static propTypes = {
    locationProfile: PropTypes.instanceOf(Map).isRequired,
    jobRequests: PropTypes.instanceOf(Map).isRequired,
  };

  renderJobRequests = () => {
    const { jobRequests } = this.props;

    if (jobRequests.size === 0) {
      return (
        <Box pam>
          <Text italic i18n="hiring.company_profile.no_jobs" />
        </Box>
      );
    }

    return jobRequests.valueSeq().map((jobRequest, i) => (
      <Box key={jobRequest.get('id')} phm>
        {i !== 0 && <hr />}

        <Box pvm>
          <Box vcenter spacebetween>
            <a href={jobRequest.get('url')} onClick={this.trackJobRequestLink}>
              {jobRequest.get('role_name')}
            </a>
            <Button
              href={jobRequest.get('url')}
              className={this.cxEl('button')}
              onClick={this.trackJobRequestButton}
            >
              <Text i18n="actions.view" />
            </Button>
          </Box>
        </Box>
      </Box>
    ));
  };

  render() {
    return (
      <Box className={this.cx()}>
        {this.renderJobRequests()}

        {this.props.locationProfile.get('active') && (
          <LocationProfileRow locationProfile={this.props.locationProfile} />
        )}
      </Box>
    );
  }
}
